// context.ts — the viewer context + hook, kept out of the provider module so that file
// only exports components (React Fast Refresh requirement).

import { createContext, useContext } from 'react';
import type { PostImage } from '@/core/models/post';

export interface MediaViewerApi {
  open: (items: PostImage[], index?: number) => void;
  close: () => void;
}

/** No-op default: unit tests render PostCard without a provider, and a media frame that
 *  simply does nothing on click is far better than a thrown error. */
const NOOP: MediaViewerApi = { open: () => {}, close: () => {} };

export const MediaViewerContext = createContext<MediaViewerApi>(NOOP);

export function useMediaViewer(): MediaViewerApi {
  return useContext(MediaViewerContext);
}
